import React from 'react';
import { Typography } from '@/components/common';
import clsx from 'clsx';

export const Summary: React.FC = () => {
	const data = [
		{
			title: '+50',
			description: 'Years',
		},
		{
			title: '+5B',
			description: 'Recovered',
		},
		{
			title: '$0',
			description: 'Upfront Fees',
		},
	];
	return (
		<section className="bg-white lg:h-[230px] mt-14 lg:mt-7 relative overflow-hidden bg-[url('/img/landing/about-us/bubble-summary-about-mobile.svg')] lg:bg-[url('/img/landing/about-us/bubble-summary-about.svg')] bg-no-repeat bg-center">
			<div className="grid grid-cols-3 place-items-center h-full border-r relative z-10">
				{data.map(({ title, description }, index) => (
					<div
						key={index}
						className={clsx('flex justify-center items-center w-full', {
							'border-x-2 border-primary': index === 1,
						})}
					>
						<div className={clsx('flex flex-col justify-between items-center')}>
							<Typography
								type="custom-h1"
								className={clsx('text-[40px] lg:text-[64px] font-bold')}
							>
								{title}
							</Typography>
							<Typography type="regular-20" className="!text-sm lg:!text-xl">
								{description}
							</Typography>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};
